import React from 'react';

export default function SolutionOverview() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto space-y-14">

        {/* Section Title */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Introducing Million2Trillion (M2T)
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            M2T is a unified, role-based platform built for financial market professionals — giving them tools to build trust, monetize, and collaborate across borders.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🔐 SmartCard Login</h3>
            <p>
              Verified, role-based identity that travels across dashboards, services, and opportunities.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📊 Personalized Dashboards</h3>
            <p>
              Each role gets its own tailored interface — whether you're a trader, mentor, analyst, or fund manager.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🛒 Marketplace & Job Board</h3>
            <p>
              Access paid gigs, publish services, or hire verified pros — all with role tags and rating history.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📈 TradingView + Signal Tools</h3>
            <p>
              Built-in charts, signal publishing, and strategy validation — integrated and monetizable.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🚀 Monetization Layers</h3>
            <p>
              Role-specific SaaS, affiliate boosters, licensing, investor zones — real revenue at every step.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">💬 Community & Collaboration</h3>
            <p>
              A clean, verified space to collaborate, share strategies, promote services, or mentor others.
            </p>
          </div>

        </div>

        {/* Optional Video or Visual Block */}
        <div className="text-center pt-10">
          <p className="text-sm text-gray-500 mb-4">
            Want to see how it works?
          </p>
          <a
            href="https://demo.million2trillion.com" // Replace with your demo/video link
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg font-semibold shadow"
          >
            Watch Platform Demo
          </a>
        </div>

      </div>
    </section>
  );
}
